<template>
    <div id="share-cloud">
      <!-- 网络异常 -->
      <share-error ref="ShareError" v-if="isShowReload"></share-error>
      <receive-applet-a :cloudData="cloudData" v-if="testA" />
      <receive-applet-b :cloudData="cloudData" v-else />
    </div>
</template>

<script type="text/ecmascript-6">
import YunJi from '@/assets/js/YunJi'
import * as Http from '@/pages/commodity/api/share'
import * as Util from '@/assets/js/Util'

import ShareError from '@/pages/commodity/components/ShareError'
import receiveAppletA from '@/pages/commodity/views/ShareCloud/components/receiveAppletA'
import receiveAppletB from '@/pages/commodity/views/ShareCloud/components/receiveAppletB'

export default {
  name: 'share-cloud',
  data() {
    return {
      shopId: YunJi.getUrlParams('shopId'),
      seqId: YunJi.getUrlParams('seqId') || '',
      shareConsumerId: YunJi.getUrlParams('shareConsumerId') || '',
      appCont: YunJi.getUrlParams('appCont') || 0,
      ticket: YunJi.getUrlParams('ticket'),
      pageIndex: 0,
      pageSize: 20,
      personalItem: {},
      isShowReload: false,
      cloudData: {},
      sourceContentId: YunJi.getUrlParams('sourceContentId'),
      testA: +YunJi.getUrlParams('abTest') !== 2,
    }
  },
  components: { 
    ShareError, receiveAppletA, receiveAppletB
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  activated() {
   
  },
  mounted() {
    this.getCouponShare()
    window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  methods: {
    beforeunloadFn(e) {
      if (this.testA) {
        return
      }
      let ids = Util.exposureThinkingReport()
      window.thinkingReport.track('exposure', {
        page_id: '80612',
        point_id: '26436',
        content_type: '内容类型',
        item_id : ids.join(','),
        point_name : '离开曝光'
      })
      console.log({
        page_id: '80612',
        point_id: '26436',
        content_type: '内容类型',
        item_id : ids.join(','),
        point_name : '离开曝光'
      })
    },
    // 获取基本信息
    getCouponShare() {
      const params = {
        seqId: this.seqId,
        shopId: this.shopId,
        appCont: this.appCont,
        shareConsumerId: this.shareConsumerId,
        ticket: this.ticket
      }
      Http.getCouponShare(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.cloudData = res.data
          window.thinkingReport.track('page_load', {
            page_id: '80612',
            point_id: '25851',
            source_content_id: this.sourceContentId,
            business_state: this.cloudData.type === 1 ? '领取成功' : this.cloudData.type === 2 ? '已领完' : '已过期'
          })
        } else if (res.errorCode !== 2418) {
          this.isShowReload = true // errorCode != 0 显示重新加载
        }
      }).catch(() => {
        this.isShowReload = true // errorCode != 0 显示重新加载
      })
    },
  }
}
</script>

<style>

</style>
